import superagentPromise from 'superagent-promise'
import _superagent from 'superagent'
import { mock } from 'agent'

const superagent = superagentPromise(_superagent, global.Promise)

const responseBody = res => res.body

const get = (API, url) => superagent.get(`${API}${url}`).then(responseBody)

const Auth = {
  current: () => get(mock, '/user.json'),
  account: () => get(mock, '/account.json'),
  login: () => get(mock, '/user-token.json')
}

const Dashboard = {
  getFirst: () => get(mock, '/dashboard.json'),
  get: () => get(mock, '/dashboard.json'),
  websiteAudit: () => get(mock, '/dashboard/website-audits.json'),
  seoSavings: () => get(mock, '/dashboard/seo-savings.json'),
  seoChecklist: () => get(mock, '/dashboard/seo-checklist.json'),
  notifications: () => get(mock, '/dashboard/notifications.json'),
  lists: () => get(mock, '/dashboard/lists.json'),
  reports: () => get(mock, '/dashboard/reports.json'),
  keywordFinders: () => get(mock, '/dashboard/keyword-finders.json')
}

const Domains = {
  all: () => get(mock, '/domains.json'),
  get: () => get(mock, '/domains.json'),
  del: () => get(mock, '/domains.json'),
  create: () => get(mock, '/domains.json'),
  update: () => get(mock, '/domains.json'),
  metrics: () => get(mock, '/domains/keyword-metrics.json'),
  pages: () => get(mock, '/domains/keywords/pages.json'),
  pageChanges: () => get(mock, '/domains/keywords/pages/changes.json'),
  grossing: () => get(mock, '/domains/keywords/grossing.json'),
  discovery: () => get(mock, '/domains/keywords/discovery.json'),
  savingsChart: () => get(mock, '/domains/keywords/savings-chart.json'),
  tags: () => get(mock, '/domains/tags.json'),
  visibility: () => get(mock, '/domains/visibility.json'),
  overview: () => get(mock, '/domains/overview.json'),
  averagePosition: () => get(mock, '/domains/average-position.json'),
  traffic: () => get(mock, '/domains/traffic.json'),
  position: () => get(mock, '/domains/position.json'),
  serpFeatureChart: () => get(mock, '/domains/serp-feature-chart.json'),
  serpFeature: () => get(mock, '/domains/serp-feature.json'),
  competitors: () => get(mock, '/domains/keywords/competitors.json'),
  shareLink: () => get(mock, '/domains/share.json')
}

const Tags = {
  create: () => get(mock, '/domains/tags.json'),
  del: () => get(mock, '/domains/tags.json'),
  update: () => get(mock, '/domains/tags.json'),
  addTagsToKeywords: () => get(mock, '/domains/taggings/add.json'),
  deleteTagsFromKeywords: () => get(mock, '/domains/taggings/remove.json')
}

const Keywords = {
  // Export Keywords
  exportKeywordsExcel: () => get(mock, '/domains/keywords/excel.json'),
  exportKeywordsCSV: () => get(mock, '/domains/keywords/csv.json'),

  // Export Competitors
  exportCompetitorsExcel: () => get(mock, '/domains/keywords/competitors/excel.json'),
  exportCompetitorsCSV: () => get(mock, '/domains/keywords/competitors/csv.json'),

  // Export Pages
  exportPagesExcel: () => get(mock, '/domains/keywords/pages/excel.json'),
  exportPagesCSV: () => get(mock, '/domains/keywords/pages/csv.json'),

  // Export Metrics
  exportMetricsExcel: () => get(mock, '/domains/keywords/metrics/excel.json'),
  exportMetricsCSV: () => get(mock, '/domains/keywords/metrics/csv.json'),

  // Export Grossing
  exportGrossingExcel: () => get(mock, '/domains/keywords/grossing/excel.json'),
  exportGrossingCSV: () => get(mock, '/domains/keywords/grossing/csv.json'),

  // Export Discovery
  exportDiscoveryExcel: () => get(mock, '/domains/keywords/discovery/excel.json'),
  exportDiscoveryCSV: () => get(mock, '/domains/keywords/discovery/csv.json'),

  // Export Savings
  exportSavingsExcel: () => get(mock, '/domains/keywords/savings/excel.json'),
  exportSavingsCSV: () => get(mock, '/domains/keywords/savings/csv.json'),

  // Export Notifications
  exportNotificationsExcel: () => get(mock, '/domains/keywords/notifications/excel.json'),
  exportNotificationsCSV: () => get(mock, '/domains/keywords/notifications/csv.json'),

  get: () => get(mock, '/domains/keywords.json'),
  getResults: () => get(mock, '/domains/keywords/results.json'),
  getChanges: () => get(mock, '/domains/keywords/changes.json'),
  add: () => get(mock, '/domains/keywords.json'),
  update: () => get(mock, '/domains/keywords.json'),
  history: () => get(mock, '/domains/keywords/history.json'),
  serp: () => get(mock, '/domains/keywords/serp.json'),
  serpHistory: () => get(mock, '/domains/keywords/serp-feature-history}.json'),
  del: () => get(mock, '/domains/keywords/batch_destroy.json'),
  competitors: () => get(mock, '/domains/keywords/competitors}.json'),
  notifications: () => get(mock, '/domains/keywords/notifications}.json')
}

const Competitors = {
  export: () => get(mock, '/domains/competitors/csv.json'),
  byDomain: () => get(mock, '/domains/competitors/overview.json'),
  del: () => get(mock, '/domains/competitors/competitor.json.json'),
  history: () => get(mock, '/domains/competitors/history.json'),
  overview: () => get(mock, '/domains/competitors/overview.json'),
  visibility: () => get(mock, '/domains/competitors/visibility.json'),
  traffic: () => get(mock, '/domains/competitors/traffic.json'),
  position: () => get(mock, '/domains/competitors/position.json'),
  averagePosition: () => get(mock, '/domains/competitors/average-position.json'),
  serpFeature: () => get(mock, '/domains/competitors/serp-feature.json'),
  serpFeatureChart: () => get(mock, '/domains/competitors/serp-feature-chart.json')
}

const Billing = {
  changePlan: () => get(mock, '/change-plan.json'),
  purchaseAddon: () => get(mock, '/add-addon.json'),
  getInvoices: () => get(mock, '/account/invoices.json')
}

const Users = {
  getAll: () => get(mock, '/account/users.json'),
  get: () => get(mock, '/account/users.json'),
  create: () => get(mock, '/account/users.json'),
  update: () => get(mock, '/account/users.json'),
  del: () => get(mock, '/account/users.json')
}

const Lists = {
  getAll: () => get(mock, '/lists.json'),
  get: () => get(mock, '/lists.json'),
  create: () => get(mock, '/lists.json'),
  update: () => get(mock, '/lists.json'),
  del: () => get(mock, '/lists.json'),
  deleteKeywords: () => get(mock, '/lists.json'),
  export: () => get(mock, '/lists.json')
}

const Reports = {
  get: () => get(mock, '/domains/reports/report.json'),
  getPrevious: () => get(mock, '/domains/reports/report.json'),
  create: () => get(mock, '/domains/reports/report.json'),
  update: () => get(mock, '/domains/reports/report.json'),
  del: () => get(mock, '/domains/reports/report.json'),
  export: () => get(mock, '/domains/reports/export.json')
}

const Checklist = {
  getAll: () => get(mock, '/domains/seo-strategy.json'),
  update: () => get(mock, '/domains/seo-strategy.json')
}

const KeywordFinder = {
  get: () => get(mock, '/keyword-finder/suggestions.json'),
  getLocales: () => get(mock, '/locations.json'),
  getSerp: () => get(mock, 'empty.json'),
  getSuggestions: () => get(mock, 'empty.json'),
  getHistory: () => get(mock, 'empty.json'),
  getPrevious: () => get(mock, 'empty.json'),
  related: () => get(mock, 'empty.json'),
  ideas: () => get(mock, 'empty.json')
}

const BacklinkChecker = {
  get: () => get(mock, '/backlink-checker/results.json'),
  getHistory: () => get(mock, 'empty.json'),
  getPrevious: () => get(mock, 'empty.json'),
}

const SerpChecker = {
  get: () => get(mock, '/serp-checker.json'),
  getPrevious: () => get(mock, '/serp-checker.json'),
  getHistory: () => get(mock, '/serp-checker.json')
}

const WebsiteAudit = {
  getAll: () => get(mock, '/domains/website-audit.json'),
  getLatest: () => get(mock, '/domains/website-audit/report.json'),
  get: () => get(mock, '/domains/website-audit/report.json'),
  getCrawlData: () => get(mock, '/domains/website-audit/crawled-pages.json'),
  export: () => get(mock, '/domains/website-audit/export.json'),
  generateSitemap: () => get(mock, '/domains/website-audit/sitemap-export.json'),
  restartAudit: () => get(mock, '/domains/website-audit/restart.json')
}

const mockedAgent = {
  Auth,
  Domains,
  Keywords,
  Billing,
  Users,
  Competitors,
  Reports,
  Checklist,
  KeywordFinder,
  BacklinkChecker,
  SerpChecker,
  WebsiteAudit,
  Dashboard,
  Lists,
  Tags
}

export default mockedAgent
